import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  isPlayersScoreLoading: true,
  scores: {},
}

// getters
export const getters = {
  getScoresByFilter: ({ scores }) => ({ filter, value, leagueId }) => scores[`${leagueId}-${filter}-${value}`] || [],
  // getMyScorePosition: ({ scores }) => score.find(({ isMyPosition }) => isMyPosition),
}
// mutations
export const mutations = {
  fetchPlayersScoreStarted(state) {
    state.isPlayersScoreLoading = true
  },
  fetchPlayersScoreSuccess(state, { filter, leagueId, playersScore }) {
    const score = Object.values(playersScore)
    Vue.set(state.scores, `${leagueId}-${filter}`, score)
    state.isPlayersScoreLoading = false
  },
  fetchPlayersScoreFailed(state) {
    state.isPlayersScoreLoading = false
  },
}
// actions
export const actions = {
  async fetchPlayersScore({ commit, getters: { getScoresByFilter } }, { leagueId, filter, value }) {
    const fetchedPlayersScore = getScoresByFilter({ filter, value, leagueId })
    if (fetchedPlayersScore.length) {
      return fetchedPlayersScore
    }
    let playersScore = null
    try {
      commit('fetchPlayersScoreStarted')
      playersScore = await axios.post(`league/${leagueId}/seasonPlayersScores`, {
        round_id: filter === 'round' && value,
        season_id: filter === 'season' && value,
        date: filter === 'month' && value,
      })
      commit('fetchPlayersScoreSuccess', {
        filter: `${filter}-${value}`,
        leagueId,
        playersScore,
      })
    } catch (e) {
      commit('fetchPlayersScoreFailed')
    }
    return playersScore
  },
}
